import React from 'react';
import "./RefundPolicy.css";

const RefundPolicy = () => (
  <div className="policy-container">
    <h2 className="policy-title">REFUND & EXCHANGE POLICY</h2>
    <p className="policy-intro">
      At <strong>Posher</strong>, each piece is made with care and attention to detail. 
      We want you to love your purchase, but in case you are not fully satisfied, 
      please read our policy below:
    </p>

    <ol className="policy-list">
      <li>No refunds on custom-made or tailored orders.</li>
      <li>
        Refunds are only possible on ready-to-wear items returned within 
        <strong> 7 days of delivery</strong>, unworn and in perfect condition 
        with original tags and packaging.
      </li>
      <li>Shipping fees are non-refundable.</li>
      <li>
        Once your return is approved, refunds will be processed within 
        <strong> 7–14 working days</strong> to your original method of payment.
      </li>
      <li>
        For exchange requests, we will happily assist with sizing or product 
        replacement (subject to availability).
      </li>
    </ol>

    <p className="policy-contact">
      To request a return or exchange, kindly contact us via 
      <strong> Instagram DM</strong> or <strong>WhatsApp</strong> before sending back the item.
    </p>
  </div>
);

export default RefundPolicy;
